import React, { useState } from 'react';
import InsightCard from './InsightCard';
import '../../styles/Dashboard/Insights.css';

const Insights = () => {
  const [activeTab, setActiveTab] = useState('average-order');
  const [timeframe, setTimeframe] = useState('This Week');

  const tabs = [
    { id: 'all', label: 'All' },
    { id: 'customer', label: 'Customer' },
    { id: 'average-order', label: 'Average order value' },
    { id: 'repeat-sales', label: 'Repeat sales' }
  ];

  const insightData = {
    customer: {
      title: 'Customer',
      totalCustomer: '5,469',
      growth: '+5%',
      previousWeek: '3,579',
      lastWeek: '4,659'
    },
    averageOrder: {
      title: 'Average order value',
      targetValue: '$ 3,579',
      actualValue: '$ 4,659'
    },
    repeatSales: {
      title: 'Repeat sales',
      targetValue: '$ 5,579',
      actualValue: '$ 4,659'
    }
  };

  const cards = [
    { type: 'customer', data: insightData.customer },
    { type: 'average-order', data: insightData.averageOrder },
    { type: 'repeat-sales', data: insightData.repeatSales }
  ];

  return (
    <div className="insights-container">
      <div className="insights-header">
      
        <div className="tabs rounded">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab rounded ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
       
        <div className="timeframe-controls">
          <select 
            value={timeframe} 
            onChange={(e) => setTimeframe(e.target.value)}
            className="timeframe-select"
          >
            <option>This Week</option>
            <option>Last Week</option>
            <option>This Month</option>
          </select>
          <button className="more-options">⋮</button>
        </div>
      </div>
    
      <div className="insights-grid">
        {cards.map(card => (
          <InsightCard 
            key={card.type}
            type={card.type}
            data={card.data}
            isActive={true}
            isFocused={activeTab === card.type || activeTab === 'all'}
          />
        ))}
      </div>
    </div>
  );
};

export default Insights;